export default __webpack_public_path__ + "static/media/wifi.d4826778.svg";